<template>
  <div>
    <el-form :model="basicData" :rules="rules" ref="basicData" label-width="100px">
      <div class="topFrom" ref="sub">
        <el-row>
          <el-col :span="6">
            <el-form-item :label="$t('purchaseReturn.form.returnNo')">
              <el-input
                v-model="basicData.returnNo"
                :disabled="true"
                :placeholder="$t('purchaseReturn.form.returnNoPlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="isReturn" :label="$t('purchaseReturn.form.isReturn')">
              <el-select
                style="width: 100%"
                v-model="basicData.isReturn"
                :disabled="true"
                @change="changeMethord"
                :placeholder="$t('purchaseReturn.form.isReturnPlaceholder')"
              >
                <el-option
                  v-for="item in isReturnList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="basicData.isReturn == 0">
            <el-form-item prop="returnMethod" :label="$t('purchaseReturn.form.exchangeMethod')">
              <el-select
                style="width: 100%"
                v-model="basicData.returnMethod"
                :disabled="canNotEdit"
                filterable
                :placeholder="$t('purchaseReturn.form.exchangeMethodPlaceholder')"
                clearable
              >
                <el-option
                  v-for="item in returnMethodList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="basicData.isReturn == 1">
            <el-form-item prop="returnMethod" :label="$t('purchaseReturn.form.returnMethod')">
              <el-select
                style="width: 100%"
                v-model="basicData.returnMethod"
                :disabled="canNotEdit"
                filterable
                :placeholder="$t('purchaseReturn.form.returnMethodPlaceholder')"
                clearable
              >
                <el-option
                  v-for="item in returnMethodList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="estimatedOutboundTime"
              :label="$t('purchaseReturn.form.estimatedOutboundTime')"
            >
              <el-date-picker
                v-model="basicData.estimatedOutboundTime"
                :disabled="canNotEdit"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                style="width: 100%"
                :picker-options="pickerStartOptions"
                :placeholder="$t('purchaseReturn.form.estimatedOutboundTimePlaceholder')"
                clearable
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item prop="returnCompanyCode" :label="$t('purchaseReturn.form.companyName')">
              <el-select
                style="width: 100%"
                v-model="basicData.returnCompanyCode"
                :disabled="canNotEdit"
                :placeholder="$t('purchaseReturn.form.companyNamePlaceholder')"
                @change="changeCompany"
                @focus="changFocus"
                @blur="changeBlur"
                clearable
                filterable
              >
                <el-option
                  v-for="item in companyList"
                  :key="item.personCompanyCode"
                  :label="item.personCompanyName"
                  :value="item.personCompanyCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="returnDepartmentCode"
              :label="$t('purchaseReturn.form.departmentName')"
            >
              <el-select
                style="width: 100%"
                v-model="basicData.returnDepartmentCode"
                :disabled="canNotEdit"
                filterable
                :placeholder="$t('purchaseReturn.form.departmentName')"
                clearable
                @change="changeDepartment"
              >
                <el-option
                  v-for="item in businessDepartmentList"
                  :key="item.personDepartmentCode"
                  :label="item.personDepartmentName"
                  :value="item.personDepartmentCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="returnOperatorName"
              :label="$t('purchaseReturn.form.returnOperatorNo')"
            >
              <el-input
                v-model="basicData.returnOperatorName"
                :disabled="true"
                :placeholder="$t('purchaseReturn.form.returnOperatorNoPlaceholder')"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="returnSalesmanNo"
              :label="$t('purchaseReturn.form.returnSalesmanNo')"
            >
              <SearchModal
                v-if="canNotEdit == false"
                ref="searchModal"
                className="customer-search"
                :propName="person.propName"
                :propCode="person.propCode"
                model="returnSalesmanNo"
                :placeholder="$t('purchaseReturn.form.returnSalesmanNoPlaceholder')"
                :API="person.API"
                :query="person.query"
                :page="person.page"
                :searchColumns="person.searchColumns"
                :columnList="person.columnList"
                :isMultiple="true"
                :currentValue="basicData.returnSalesmanName"
                @setSearchModal="setSalesman"
              ></SearchModal>
              <el-input
                v-model="basicData.returnSalesmanName"
                v-if="canNotEdit == true"
                :disabled="true"
                :placeholder="$t('purchaseReturn.form.returnSalesmanNoPlaceholder')"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item prop="partnerCode" :label="$t('purchaseReturn.form.partnerCode')">
              <search-table
                :disabled="canNotEdit"
                v-model="basicData.partnerName"
                searchType="supplier"
                :isMultiple="true"
                :isNeedMultipleValue="true"
                :currentValue="basicData.partnerName || null"
                :checkRowKeys="[basicData.partnerCode]"
                @input="setPartner"
                :extraData="{
                  companyCode: basicData.returnCompanyCode,
                  departmentCode: basicData.returnDepartmentCode,
                }"
              ></search-table>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="outboundStorageCode"
              :label="$t('purchaseReturn.form.outboundStorageCode')"
            >
              <SearchModal
                v-if="canNotEdit == false"
                ref="searchModal"
                propName="storageName"
                className="customer-search"
                propCode="storageCode"
                model="outboundStorageCode"
                :placeholder="$t('purchaseReturn.form.outboundStorageCodePlaceholder')"
                :API="warehouse.API"
                :query="warehouse.query"
                :page="warehouse.page"
                :searchColumns="warehouse.searchColumns"
                :columnList="warehouse.columnList"
                :isMultiple="true"
                :currentValue="basicData.outboundStorageName"
                @setSearchModal="setWareHouseOut"
              ></SearchModal>
              <el-input
                v-model="basicData.outboundStorageName"
                v-if="canNotEdit == true"
                :disabled="true"
                :placeholder="$t('purchaseReturn.form.outboundStorageCodePlaceholder')"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="isDirectDeliver" label="是否直拨">
              <el-select
                style="width: 100%"
                v-model="basicData.isDirectDeliver"
                :disabled="canNotEdit"
                :clearable="true"
                filterable
                placeholder="请选择是否直拨"
              >
                <el-option :label="$t('addSupplierDelivery.option.direct')" value="1"></el-option>
                <el-option
                  :label="$t('addSupplierDelivery.option.notDirect')"
                  value="0"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="freightTaker" :label="$t('purchaseReturn.form.freightTaker')">
              <el-select
                style="width: 100%"
                v-model="basicData.freightTaker"
                :disabled="canNotEdit"
                :clearable="true"
                filterable
                :placeholder="$t('purchaseReturn.form.freightTakerPlaceholder')"
              >
                <el-option
                  v-for="item in freightTakerTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="freightAmount" :label="$t('purchaseReturn.form.freightAmount')">
              <input-number
                v-model="basicData.freightAmount"
                max="99999999999.999999"
                :precision="3"
                :placeholder="$t('purchaseReturn.form.freightAmountPlaceholder')"
                @input="(val) => handleChangeNumber(val)"
                :disabled="basicData.returnStatus == 'ZT03' || basicData.returnStatus == 'ZT02'"
              ></input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="basicData.isReturn == 1">
          <el-col :span="6">
            <el-form-item :label="$t('purchaseReturn.form.isReturnMoney')">
              <el-checkbox
                @change="changeIsReturnMoney"
                v-model="basicData.isReturnMoney"
                :disabled="canNotEdit"
              ></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="basicData.isReturnMoney">
            <el-form-item
              prop="returnMoneyMethod"
              :label="$t('purchaseReturn.form.returnMoneyMethod')"
            >
              <el-select
                style="width: 100%"
                v-model="basicData.returnMoneyMethod"
                :disabled="canNotEdit"
                filterable
                :placeholder="$t('purchaseReturn.form.returnMoneyMethodPlaceholder')"
                clearable
              >
                <el-option
                  v-for="item in returnMoneyMethodList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="supplierStorageCode"
              :label="$t('purchaseReturn.form.supplierStorageCode')"
            >
              <el-input
                v-model="basicData.supplierStorageName"
                :disabled="canNotEdit"
                :placeholder="$t('purchaseReturn.form.supplierStorageCodePlaceholder')"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="gmtCreate" :label="$t('purchaseReturn.form.gmtCreate')">
              <el-date-picker
                style="width: 100%"
                v-model="basicData.gmtCreate"
                :disabled="canNotEdit"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('purchaseReturn.form.goodList.contractNo')">
              <el-input v-model="basicData.contractNo" :disabled="true"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('purchaseReturn.form.returnCurrencyName')">
              <el-input
                v-model="basicData.returnCurrencyName"
                :disabled="true"
                :placeholder="$t('purchaseReturn.form.returnCurrencyName')"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <el-tabs type="border-card" v-model="activeNameTab" class="addCooperationTabs">
      <!-- 商品行项目 -->
      <el-tab-pane name="first" :label="$t('businessReceiptList.create.productTitle')">
        <div class="gird">
          <vxe-toolbar size="mini">
            <template v-slot:buttons>
              <vxe-button
                size="medium"
                type="primary"
                class="vxe-btn-primary"
                icon="el-icon-plus"
                @click="insetRow"
                v-if="!canNotEdit"
              >
                {{ $t('purchaseReturn.btnList.add') }}
              </vxe-button>
              <vxe-button
                size="medium"
                type="primary"
                class="vxe-btn-delete"
                icon="el-icon-delete"
                @click="removeSelected()"
                v-if="!canNotEdit"
              >
                {{ $t('purchaseReturn.btnList.del') }}
              </vxe-button>
            </template>
          </vxe-toolbar>
          <vxe-grid
            show-overflow
            show-header-overflow
            border
            resizable
            ref="exchangeTable"
            class="vxe-table-element"
            size="mini"
            align="left"
            :auto-resize="true"
            :data="tableData"
            :edit-rules="editRules"
            @cell-click="rowClick"
            :edit-config="{ trigger: 'click', mode: 'row' }"
          >
            <vxe-table-column type="checkbox" width="60"></vxe-table-column>
            <vxe-table-column type="seq" width="60" :title="$t('table.index')"></vxe-table-column>
            <!-- 采购合同号 -->
            <vxe-table-column
              width="100"
              field="contractNo"
              :title="this.$t('purchaseReturn.form.goodList.contractNo')"
            ></vxe-table-column>
            <!-- 外部合同号 -->
            <vxe-table-column
              width="100"
              field="externalContractNo"
              :title="this.$t('purchaseReturn.form.goodList.externalContractNo')"
            ></vxe-table-column>
            <!-- 采购合同行项目号 -->
            <vxe-table-column
              width="150"
              field="contractDetailNo"
              :title="this.$t('purchaseReturn.form.goodList.contractDetailNo')"
            ></vxe-table-column>
            <!-- 商品描述 -->
            <vxe-table-column
              field="productName"
              :title="$t('purchaseReturn.form.goodList.productCode')"
              min-width="100"
            ></vxe-table-column>
            <!-- 业务入库单号 -->
            <vxe-table-column
              field="businessInboundNo"
              :edit-render="{ name: 'input' }"
              :title="$t('purchaseReturn.form.goodList.businessInboundNo')"
              min-width="140"
            >
              <template v-slot:edit="{ row }">
                <el-input disabled v-model="row.businessInboundNo"></el-input>
              </template>
            </vxe-table-column>
            <!-- 退货数量 -->
            <vxe-table-column
              field="returnQuantity"
              :title="$t('purchaseReturn.form.goodList.returnQuantity')"
              :edit-render="{ name: 'input' }"
              min-width="110"
            >
              <template v-slot:edit="scope">
                <span v-if="canNotEdit">{{ scope.row.returnQuantity }}</span>
                <QuantityOfExchange
                  v-else
                  ref="quantityOfExchange"
                  model="returnQuantity"
                  :placeholder="$t('purchaseReturn.form.goodList.returnQuantityPlaceholder')"
                  :data="scope.row"
                  :defaultValue="scope.row.returnQuantity ? scope.row.returnQuantity : ''"
                  @setSearchModal="(val) => setQuantity(val, scope.row, scope)"
                  :disabled="
                    canNotEdit
                      ? true
                      : copyEdit
                      ? false
                      : basicData.returnStatus == 'ZT03' || basicData.returnStatus == 'ZT02'
                  "
                  @changeFocusData="getNumber(scope.row)"
                ></QuantityOfExchange>
              </template>
              <template v-slot="scope">
                {{ toFixedNumber(scope.row.returnQuantity, 3) }}
              </template>
            </vxe-table-column>
            <!-- 业务入库批次 -->
            <vxe-table-column
              :edit-render="{ name: 'input' }"
              min-width="140"
              field="businessInboundBatchNo"
              :title="this.$t('purchaseReturn.form.goodList.businessInboundBatchNo')"
            >
              <template v-slot:edit="{ row }">
                <el-input disabled v-model="row.businessInboundBatchNo"></el-input>
              </template>
            </vxe-table-column>
            <!-- 退货批次号 -->
            <vxe-table-column
              field="batchNo"
              :title="'退货批次号'"
              :edit-render="{ name: 'input' }"
              min-width="140"
            >
              <template v-slot:edit="{ row }">
                <search-table
                  ref="searchTable"
                  v-model="row.batchNo"
                  :searchType="'storageBatchForPurchaseReturn'"
                  :isMultiple="true"
                  :currentValue="row.batchNo"
                  :checkRowKeys="[row.batchNo]"
                  :extraData="{
                    batchDepartmentNo: basicData.returnDepartmentCode, // 部门编号
                    storageNo: warehouseCode, // 库存编号
                    partnerNo: basicData.partnerCode, // 供应商
                    contractInternalNo: tableData.length != 0 ? tableData[0].contractNo : null, // 合同号
                  }"
                  :disabled="canNotEdit"
                  @input="(val) => batchNoChange(val, row)"
                ></search-table>
              </template>
            </vxe-table-column>
            <!-- 单价 -->
            <vxe-table-column
              field="priceWithTax"
              :title="$t('purchaseReturn.form.goodList.businessContractPrice')"
              min-width="110"
            >
              <template v-slot="scope">
                <div v-if="basicData.currencyExchangeRate == 1">
                  {{ toFixedNumber(scope.row.priceWithTax, 2) }}
                </div>
                <div v-else>
                  <p class="break-space" v-if="scope.row.priceWithTax">
                    {{ scope.row.priceWithTax ? $t('contractAgency.productTab.originCoin') : null }}
                    {{ toFixedNumber(scope.row.priceWithTax, 2) }}
                  </p>
                  <p class="break-space" v-if="scope.row['priceWithTaxLocal']">
                    {{
                      scope.row['priceWithTaxLocal']
                        ? $t('contractAgency.productTab.localCoin')
                        : null
                    }}
                    {{ toFixedNumber(scope.row['priceWithTaxLocal'], 2) }}
                  </p>
                </div>
              </template>
            </vxe-table-column>
            <!-- 不含税单价 -->
            <vxe-table-column
              field="priceWithoutTaxLocal"
              :title="$t('purchaseReturn.form.goodList.businessContractPriceNoTax')"
              min-width="110"
            >
              <template v-slot="scope">
                <div v-if="basicData.currencyExchangeRate == 1">
                  {{ toFixedNumber(scope.row.priceWithoutTax, 2) }}
                </div>
                <div v-else>
                  <p class="break-space" v-if="scope.row.priceWithoutTax">
                    {{
                      scope.row.priceWithoutTax ? $t('contractAgency.productTab.originCoin') : null
                    }}
                    {{ toFixedNumber(scope.row.priceWithoutTax, 2) }}
                  </p>
                  <p class="break-space" v-if="scope.row['priceWithoutTaxLocal']">
                    {{
                      scope.row['priceWithoutTaxLocal']
                        ? $t('contractAgency.productTab.localCoin')
                        : null
                    }}
                    {{ toFixedNumber(scope.row['priceWithoutTaxLocal'], 2) }}
                  </p>
                </div>
              </template>
            </vxe-table-column>
            <!-- 不含税金额 -->
            <vxe-table-column
              field="returnAmountWithoutTaxLocal"
              :title="$t('purchaseReturn.form.goodList.returnAmountWithoutTax')"
              min-width="110"
            >
              <template v-slot="scope">
                <div v-if="basicData.currencyExchangeRate == 1">
                  {{ toFixedNumber(scope.row.returnAmountWithoutTax, 2) }}
                </div>
                <div v-else>
                  <p class="break-space" v-if="scope.row.returnAmountWithoutTax">
                    {{
                      scope.row.returnAmountWithoutTax
                        ? $t('contractAgency.productTab.originCoin')
                        : null
                    }}
                    {{ toFixedNumber(scope.row.returnAmountWithoutTax, 2) }}
                  </p>
                  <p class="break-space" v-if="scope.row['returnAmountWithoutTaxLocal']">
                    {{
                      scope.row['returnAmountWithoutTaxLocal']
                        ? $t('contractAgency.productTab.localCoin')
                        : null
                    }}
                    {{ toFixedNumber(scope.row['returnAmountWithoutTaxLocal'], 2) }}
                  </p>
                </div>
              </template>
            </vxe-table-column>
            <!-- 金额 -->
            <vxe-table-column
              field="returnAmount"
              :title="$t('purchaseReturn.form.goodList.returnAmount')"
              :edit-render="{ name: 'input' }"
              min-width="110"
            >
              <template v-slot:edit="{ row }">
                <input-number
                  :disabled="!isReturnMoney || canNotEdit"
                  v-model="row.returnAmount"
                  max="999999999999999999.999999"
                  :precision="3"
                  @input="(val) => inputReturnAmount(val, row)"
                ></input-number>
              </template>
              <template v-slot="scope">
                <!--如果是原币本币-->
                <!--人民币默认只显示人民币-->
                <!-- v-if="scope.row.returnCurrencyCode == 'CNY'" -->
                <!-- <p
                  class="break-space"
                >{{scope.row.returnAmountLocal}}</p> -->
                <!--其他类型要展示原币和本币-->
                <div v-if="basicData.currencyExchangeRate == 1">
                  {{ toFixedNumber(scope.row.returnAmount, 2) }}
                </div>
                <div v-else>
                  <p class="break-space" v-if="scope.row.returnAmount">
                    {{ scope.row.returnAmount ? $t('contractAgency.productTab.originCoin') : null }}
                    {{ toFixedNumber(scope.row.returnAmount, 2) }}
                  </p>
                  <p class="break-space" v-if="scope.row['returnAmountLocal']">
                    {{
                      scope.row['returnAmountLocal']
                        ? $t('contractAgency.productTab.localCoin')
                        : null
                    }}
                    {{ toFixedNumber(scope.row['returnAmountLocal'], 2) }}
                  </p>
                </div>
              </template>
            </vxe-table-column>
            <!-- 币种 -->
            <vxe-table-column
              field="returnCurrencyName"
              :title="$t('purchaseReturn.form.goodList.returnCurrency')"
              min-width="110"
            ></vxe-table-column>
            <!-- 单位 -->
            <vxe-table-column
              field="productUnit"
              :formatter="formatterUnitDict"
              :title="$t('purchaseReturn.form.goodList.productUnit')"
              min-width="110"
            ></vxe-table-column>
            <!-- 汇率 -->
            <vxe-table-column
              field="exchangeRate"
              :title="$t('purchaseReturn.form.goodList.exchangeRate')"
              min-width="110"
            ></vxe-table-column>
            <!-- 已匹配数量 -->
            <vxe-table-column
              field="invoiceQuantity"
              :title="$t('purchaseReturn.form.goodList.invoiceQuantity')"
              min-width="110"
            ></vxe-table-column>
            <!-- 可匹配数量 -->
            <vxe-table-column
              field="nonInvoiceQuantity"
              :title="$t('purchaseReturn.form.goodList.nonInvoiceQuantity')"
              min-width="110"
            ></vxe-table-column>
            <!-- 实际出库数量 -->
            <vxe-table-column
              field="actualOutboundQuantity"
              :title="$t('purchaseReturn.form.goodList.actualOutboundQuantity')"
              min-width="110"
              :edit-render="{ name: 'input' }"
            >
              <template v-slot:edit="{ row }">
                <input-number-ad
                  v-model="row.actualOutboundQuantity"
                  :max="999999999.999"
                  :min="0"
                  :precision="$globalVar.qPoint"
                  :disabled="basicData.isDirectDeliver != '1' || basicData.returnStatus != 'ZT07'"
                ></input-number-ad>
              </template>
              <template v-slot="{ row }">
                {{ $baseRequest.formatTableColumn(row.actualOutboundQuantity, $globalVar.qPoint) }}
              </template>
            </vxe-table-column>
          </vxe-grid>
        </div>
      </el-tab-pane>
      <el-tab-pane name="voucherTab" :label="$t('addInvoice.invoiceLine.title2')">
        <voucher
          ref="voucher"
          :voucherList="voucherList"
          @reverseInfo="reverseInfo"
          @postInfo="postInfo"
          @doConfirmInfo="doConfirmInfo"
        ></voucher>
      </el-tab-pane>
    </el-tabs>
    <div class="gird padding-bottom">
      <el-form :model="basicData" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('purchaseReturn.form.mark')" label-width="80px">
              <el-input
                v-model="basicData.returnMark"
                :disabled="canNotEdit"
                :placeholder="$t('purchaseReturn.form.markPlaceholder')"
                type="textarea"
                :rows="3"
                clearable
                maxlength="256"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="fixed-bottom-btnList">
      <el-button
        v-hasPermi="['2021042915443816012']"
        v-if="!canNotEdit || (basicData.isDirectDeliver == '1' && basicData.returnStatus == 'ZT07')"
        type="primary"
        @click="save"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.save') }}</el-button
      >
      <el-button
        v-hasPermi="['2021042915450308182']"
        v-if="canNotEdit == false"
        type="primary"
        @click="commit"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('purchaseReturn.btnList.commit') }}</el-button
      >
      <!-- <el-button v-if="canNotEdit == true && (basicData.returnStatus == 'ZT06'||basicData.returnStatus =='ZT05')" type="primary" @click="gotoEdit" :loading="load" class="fixed-bottom-btn">{{$t('functionBtn.edit')}}</el-button> -->
      <el-button
        v-hasPermi="['2021042915435544045']"
        v-if="basicData.returnStatus == 'ZT06' || basicData.returnStatus == 'ZT05'"
        type="primary"
        @click="del"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.delete') }}</el-button
      >
      <!-- <el-button v-if="canNotEdit == true " type="primary" @click="print" :loading="load" class="fixed-bottom-btn">{{$t('functionBtn.print')}}</el-button> -->
      <el-button
        v-if="canNotEdit == true && basicData.returnStatus == 'ZT07'"
        type="primary"
        @click="copy"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.copy') }}</el-button
      >
      <el-button
        v-if="canNotEdit == true && basicData.returnStatus == 'ZT07'"
        type="primary"
        @click="saveTransport"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('purchaseReturn.btnList.logisticsTransportation') }}</el-button
      >
      <el-button
        v-hasPermi="['2021042915465655922']"
        v-if="
          canNotEdit == true &&
          basicData.returnStatus == 'ZT03' &&
          ['notgenerate', 'generated', 'postError'].indexOf(basicData.accountingStatus) != -1
        "
        type="primary"
        @click="handleAccountEntry"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('addInvoice.btns.accountEntry') }}</el-button
      >
      <el-button
        v-hasPermi="['2021042915471837999']"
        v-if="
          canNotEdit == true &&
          basicData.returnStatus == 'ZT03' &&
          ['generated', 'postError'].indexOf(basicData.accountingStatus) != -1
        "
        type="primary"
        @click="doSyncVoucherForEntityData()"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.doSyncVoucher') }}</el-button
      >
      <el-button
        v-hasPermi="['2021042915453445344']"
        v-if="canNotEdit == true && basicData.returnStatus == 'ZT07'"
        type="primary"
        @click="doConfirm"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.confirm') }}</el-button
      >
      <el-button
        v-hasPermi="['2021042915441728500']"
        v-if="canNotEdit == true && basicData.returnStatus == 'ZT07'"
        type="primary"
        @click="doWithdraw"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.withdraw') }}</el-button
      >
      <el-button
        v-hasPermi="['2021042915462259812']"
        v-if="canNotEdit == true && basicData.returnStatus == 'ZT03'"
        type="primary"
        @click="doReverseAccountEntry()"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.writeOff') }}</el-button
      >
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import SearchModal from '@/components/SearchModal';
  import searchTable from '@/components/form-item/search-table';
  // import Exchange from './exchange';
  // import Return from './return';
  // import ReturnDetail from './returnDetail';
  // import ExchangeDetail from './exchangeDetail';
  import API from '@/api/purchaseSalesCenter/purchaseReturn.js';
  import DataBaseAPI from '@/api/dataBase';
  // import COOPERATION_API from '@/api/masterData/cooperation';
  import rules from '../rules/rules';
  import inputNumber from '@/components/form-item/input-number';
  import inputNumberAd from '@/components/form-item/input-number-advance';
  import QuantityOfExchange from './quantityOfExchange';
  import { dateFormatter } from '@/common/js/util';
  // import { dateFormat } from '@/filters/index';
  import voucherMixins from '@/common/mixins/voucher.js';

  export default {
    name: 'purchaseReturnAdd',
    mixins: [voucherMixins],
    components: {
      SearchModal,
      searchTable,
      // Exchange,
      // Return,
      // ReturnDetail,
      // ExchangeDetail,
      inputNumber,
      inputNumberAd,
      QuantityOfExchange,
    },
    data() {
      const returnQuantityValid = (rule, cellValue, callback) => {
        console.log(rule);
        if (!cellValue) {
          callback(new Error(this.$t('purchaseReturn.form.goodList.returnQuantityPlaceholder')));
        } else if (cellValue == 0) {
          callback(new Error('退货数量不能为0'));
        } else {
          callback();
        }
      };
      return {
        rowIndex: 0,
        inboundNo: '',
        returnOldBlurCode: '',
        currencyCode: null,
        currencyName: null, //存储币种
        canNotEdit: this.$route.query.canEdit == '0' ? true : false,
        load: false,
        partnerCode: '',
        warehouseCode: '',
        partnerType: '123',
        rules: rules.rules,
        editRules: {
          ...rules.exchangeTable,
          returnQuantity: [{ validator: returnQuantityValid, trigger: ['change', 'blur'] }],
        },
        isShow: 0,
        companyList: [], //公司列表
        businessDepartmentList: [], //事业部门列表
        returnMethodList: [], //退换货方式
        currencyTypeList: [], //币种
        isReturnList: [
          { value: 0, label: '换货' },
          { value: 1, label: '退货' },
        ], //性质
        freightTakerTypeList: [], //运费承担
        returnMoneyMethodList: [], //退款方式
        businessInboundNoList: [], //业务入库单号
        businessInboundBatchNoList: [], //业务入库批次
        copyEdit: false, //是否复制
        returnOldCompanyCode: null, //原公司code
        tableToolbar: {
          id: 'toolbar',
        },
        pickerStartOptions: {
          disabledDate: (time) => {
            let startDate = new Date();
            if (startDate) {
              return time.getTime() < new Date(startDate).getTime() - 24 * 60 * 60 * 1000;
            }
          },
        },
        tableData: [{}],
        isReturnMoney: false,
        basicData: {
          isReturn: 1,
          returnOperatorName: '',
          returnOperatorNo: '',
          returnSalesmanName: '',
          returnSalesmanNo: '',
          returnDepartmentName: '',
          returnDepartmentCode: '',
          returnCompanyName: '',
          returnCompanyCode: '',
          outboundStorageCode: '',
          outboundStorageName: '',
          supplierStorageCode: '',
          supplierStorageName: '',
          isDirectDeliver: '0',
          partnerCode: '',
          partnerName: '',
          gmtCreate: dateFormatter(new Date(), false),
          contractNo: '',
          returnCurrencyCode: null,
          returnCurrencyName: null,
          currencyExchangeRate: 1,
        },
        voucherFlag: 'AE_PO_MTL_RETURN', //凭证标识
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      //仓库
      warehouse() {
        return {
          propName: 'storageName', // 输入框展示内容
          propCode: 'storageCode',
          query: {
            storageCode: '',
            storageName: '',
            adminFlag: this.userInfo.userInfo.adminFlag,
            //已生效的仓库
            currentStatus: 'ZT03',
          },
          searchColumns: [
            {
              prop: 'storageCode',
              name: window.vm.$t('warehouse.search.warehouseCode'),
              type: 'input',
              placeholder: window.vm.$t('warehouse.search.warehouseCodePlaceholder'),
            },
            {
              prop: 'storageName',
              name: window.vm.$t('warehouse.search.warehouseName'),
              type: 'input',
              placeholder: window.vm.$t('warehouse.search.warehouseNamePlaceholder'),
            },
          ],
          API: DataBaseAPI.STORAGE_LIST_API,
          columnList: [
            {
              prop: 'storageCode',
              label: window.vm.$t('warehouse.table.createWarehouseCode'),
            },
            {
              prop: 'storageName',
              label: window.vm.$t('warehouse.table.createWarehouseName'),
            },
            {
              prop: 'storageAddress',
              label: window.vm.$t('warehouse.table.createWarehouseAddress'),
            },
            {
              prop: 'storageCompanyCode',
              label: window.vm.$t('warehouse.table.createWarehouseCompanyCode'),
            },
            {
              prop: 'storageCompanyName',
              label: window.vm.$t('warehouse.table.createWarehouseCompanyName'),
            },
            {
              prop: 'personName',
              label: window.vm.$t('warehouse.table.gmtCreateBy'),
            },
            {
              prop: 'storageCreateTime',
              label: window.vm.$t('warehouse.table.gmtCreate'),
            },
            // { prop: "currentStatus", label: window.vm.$t("warehouse.table.status") }
          ],
        };
      },
      //商品子类
      goods() {
        return {
          width: '800',
          query: {
            detailProductDisplayName: null,
            productDetailCode: null,
          },
          API: DataBaseAPI.LIST_DETAIL_PRODUCT,
          extraData: {
            //已生效
            detailProductStatus: 'ZT03',
            adminFlag: this.userInfo.adminFlag,
            selectCompanyCode: this.userInfo.companyCode,
          },
          propCode: 'productDetailCode',
          propName: 'detailProductDisplayName',
          searchColumns: [
            {
              prop: 'productDetailCode',
              name: window.vm.$t('goods.search.productDetailCode'),
              type: 'input',
              placeholder: '请输入',
            },
            {
              name: window.vm.$t('goods.search.detailProductDisplayName'),
              prop: 'detailProductDisplayName',
              type: 'input',
              placeholder: '请输入',
            },
          ],
          columnList: [
            {
              prop: 'productDetailCode',
              label: window.vm.$t('goods.table.productDetailCode'),
              width: 200,
            },
            {
              prop: 'detailProductDisplayName',
              label: window.vm.$t('goods.table.detailProductDisplayName'),
              width: 200,
            },
            {
              prop: 'detailProductModel',
              label: window.vm.$t('goods.table.detailProductModel'),
            },
          ],
        };
      },
      //人员
      person() {
        return {
          API: DataBaseAPI.PERSON_LIST_API,
          propCode: 'id',
          propName: 'personName', // 输入框展示内容
          query: {
            userCompany: null,
            dataStatus: 'ZT03',
          },
          searchColumns: [
            {
              name: window.vm.$t('personnel.search.personnelInformation'),
              prop: 'personInfo',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'personNo',
              label: window.vm.$t('personnel.addpersonnel.personNo'),
              width: 100,
            },
            {
              prop: 'personName',
              label: window.vm.$t('personnel.table.Name'),
              width: 100,
            },
            {
              prop: 'personCompanyName',
              label: window.vm.$t('personnel.table.company'),
              width: 150,
            },
            {
              prop: 'personDepartmentName',
              label: window.vm.$t('personnel.table.department'),
            },
            {
              prop: 'personMobilePhone',
              label: window.vm.$t('personnel.table.phone'),
              width: 100,
            },
            {
              prop: 'personEmail',
              label: window.vm.$t('personnel.table.email'),
              width: 120,
            },
            {
              prop: 'dataStatus',
              label: window.vm.$t('personnel.table.dataState'),
              width: 100,
            },
          ],
        };
      },
    },
    created() {
      this.getData();
    },
    /**页面必要代码Start */
    mounted() {
      if (this.$route.query.canEdit == '0') {
        this.canNotEdit = true;
      } else {
        this.canNotEdit = false;
      }
      if (!this.$route.query.returnNo) {
        this.basicData.returnOperatorName = this.userInfo.userInfo.userName;
        this.basicData.returnOperatorNo = this.userInfo.userInfo.userCode;
        this.basicData.returnSalesmanName = this.userInfo.userInfo.userName;
        this.basicData.returnSalesmanNo = this.userInfo.userInfo.userCode;
        this.basicData.returnCompanyCode = this.userInfo.userInfo.companyCode;
        this.basicData.returnDepartmentCode = this.userInfo.userInfo.departmentCode;
        this.basicData.returnCompanyName = this.userInfo.userInfo.companyName;
        this.basicData.returnDepartmentName = this.userInfo.userInfo.departmentName;
        this.companyList = JSON.parse(this.userInfo.userInfo.companyList);

        if (this.basicData.returnCompanyCode) {
          this.getCurrany(this.basicData.returnCompanyCode);
          this.initDepartment();
        }
      }
      //复制的批次可以编辑
      if (this.$route.query.copy) {
        if (this.$route.query.copy == '0') {
          this.copyEdit = true;
        }
      }
      this.warehouse.query.adminFlag = this.userInfo.userInfo.adminFlag;
      this.getDic();
    },
    methods: {
      //设置供应商
      setPartner(row) {
        if (row && row.length > 0) {
          this.basicData.partnerCode = row[0].partnerCode;
          this.basicData.partnerName = row[0].partnerZhName;
          if (this.partnerCode != row[0].partnerCode) {
            this.partnerCode = row[0].partnerCode;
            this.tableData = [];
          }
        } else {
          this.basicData.partnerCode = '';
          this.basicData.partnerName = '';
          this.partnerCode = '';
        }
      },
      formatterPartnerType({ cellValue }) {
        return this.$baseRequest.getDictValueByType('partner_type', cellValue);
      },
      formatterUnitDict({ cellValue }) {
        return this.$baseRequest.getDictValueByType('basic_unit', cellValue);
      },
      // 退货批次号
      batchNoChange(val, row) {
        row.returnQuantity = ''; // 退货数量
        row.returnAmount = ''; // 金额
        row.returnAmountLocal = ''; // 金额本币
        row.returnAmountWithoutTax = ''; // 不含税金额
        row.returnAmountWithoutTaxLocal = ''; // 不含税金额本币
        if (val && val.length > 0) {
          row.contractNo = val[0].contractInternalNo; // 采购合同号
          row.externalContractNo = val[0].externalContractNo; // 外部合同号
          row.contractDetailNo = val[0].contractInternalDetailNo; // 采购合同行项目号
          row.productCode = val[0].productDetailNo; // 商品编号
          row.productName = val[0].productName; // 商品描述
          row.businessInboundNo = val[0].businessInboundNo; // 业务入库单号
          row.businessInboundBatchNo = val[0].originalBatchNo; // 业务入库批次号
          row.batchNo = val[0].batchNo; // 退货批次号
          row.priceWithTax = row.businessContractPrice = val[0].inboundPrice; // 含税单价
          row.priceWithTaxLocal = val[0].companyInboundPrice; // 含税单价本币
          row.priceWithoutTax = val[0].inboundWithouttaxPrice; //不含税单价
          row.priceWithoutTaxLocal = val[0].inboundCompanyWithouttaxPrice; // 不含税单价本币
          row.returnCurrencyCode = val[0].currencyCode;
          row.returnCurrencyName = val[0].currencyName; // 币种
          row.productUnit = val[0].productUnit; // 单位
          row.exchangeRate = val[0].exchangeRate; // 汇率
          row.inboundQuantity = val[0].inboundQuantity; // 入库数量
          row.availableNum = row.quantity = val[0].availableQuantity; // 可用库存数量
          row.taxCode = val[0].taxCode; // 税码
          row.taxRate = val[0].taxRate; // 税率

          //合同号
          this.basicData.contractNo = val[0].contractInternalNo;
          //货币
          this.basicData.returnCurrencyCode = val[0].currencyCode;
          this.basicData.returnCurrencyName = val[0].currencyName;
          this.getExchangeRate().then(() => {
            const params = {
              purchaseReturnDetails: [],
              currencyExchangeRate: this.basicData.currencyExchangeRate,
            };
            params.purchaseReturnDetails.push(row);

            this.$refs.exchangeTable.updateData();
            if (val[0].currencyCode) {
              this.$axios.post(API.CALCULATE_AMOUNT, params).then((res) => {
                if (res.data.code == 0) {
                  row.businessContractPrice = res.data.data.purchaseReturnDetails[0].priceWithTax;
                  this.updateRow(
                    this.tableData[this.rowIndex],
                    res.data.data.purchaseReturnDetails[0]
                  );
                  this.$refs.exchangeTable.updateData();
                } else {
                  for (let i in row) {
                    row[i] = '';
                  }
                  this.$refs.exchangeTable.updateData();
                  this.$alert(this.$t('businessReceiptList.table.pleaseMakeExchangeRate'));
                }
              });
            }
          });
        } else {
          row.contractNo = ''; // 采购合同号
          row.externalContractNo = ''; // 外部合同号
          row.contractDetailNo = ''; // 采购合同行项目号
          row.productCode = ''; // 商品编号
          row.productName = ''; // 商品描述
          row.businessInboundNo = ''; // 业务入库单号
          row.businessInboundBatchNo = ''; // 业务入库批次号
          row.batchNo = ''; // 退货批次号
          row.priceWithTax = row.businessContractPrice = ''; // 含税单价
          row.priceWithTaxLocal = ''; // 含税单价本币
          row.priceWithoutTax = ''; //不含税单价
          row.priceWithoutTaxLocal = ''; // 不含税单价本币
          row.returnCurrencyCode = '';
          row.returnCurrencyName = ''; // 币种
          row.productUnit = ''; // 单位
          row.exchangeRate = ''; // 汇率
          row.inboundQuantity = ''; // 入库数量
          row.availableNum = row.quantity = ''; // 可用库存数量
          row.taxCode = ''; // 税码
          row.taxRate = ''; // 税率

          //合同号
          this.basicData.contractNo = '';
          //货币
          this.basicData.returnCurrencyCode = '';
          this.basicData.returnCurrencyName = '';
          // this.getExchangeRate().then(()=>{
          //   const params= {
          //     purchaseReturnDetails: [],
          //     currencyExchangeRate: this.basicData.currencyExchangeRate
          //   }
          //   params.purchaseReturnDetails.push(row)

          //   this.$refs.exchangeTable.updateData();
          //   if(val[0].currencyCode){
          //     this.$axios.post(API.CALCULATE_AMOUNT,params).then(res=>{
          //       if(res.data.code == 0){
          //         row.businessContractPrice = res.data.data.purchaseReturnDetails[0].priceWithTax;
          //         this.updateRow(this.tableData[this.rowIndex], res.data.data.purchaseReturnDetails[0])
          //         this.$refs.exchangeTable.updateData()
          //       } else {
          //         for (let i in row) {
          //           row[i] = "";
          //         }
          //         this.$refs.exchangeTable.updateData()
          //         this.$alert(this.$t("businessReceiptList.table.pleaseMakeExchangeRate"));
          //       }
          //     })
          //   }
          // })
        }
      },
      // toFixedNumber,
      //业务部门
      initDepartment() {
        const params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
          personCompanyCode: this.basicData.returnCompanyCode,
        };
        this.$axios.post(DataBaseAPI.GET_PERSON_API, params).then((res) => {
          if (0 == res.data.code) {
            this.businessDepartmentList = res.data.data.personDepartmentInfo;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //获取公司信息
      getCompany() {},
      changFocus() {
        this.returnOldCompanyCode = this.basicData.returnCompanyCode;
      },
      changeBlur() {
        this.returnOldBlurCode = this.basicData.returnCompanyCode;
      },
      //获取字典值
      getDic() {
        const tenantCode = this.userInfo.tenantCode; // 租户编码
        // 合作伙伴类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'partner_type', tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.partnerTypeList = res.data.data; // 下拉
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
        //运费承担
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'freight_taker', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.freightTakerTypeList = res.data.data;
            }
          });
        //退换货方式
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'return_method', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.returnMethodList = res.data.data;
            }
          });
        //退款方式
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'pay_method', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.returnMoneyMethodList = res.data.data;
            }
          });
        //单据状态
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'request_status', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.requestStatusList = res.data.data;
            }
          });
      },
      //选择仓库(出库)
      setWareHouseOut(val, row) {
        if (row && row.length > 0) {
          // this.basicData.isDirectDeliver = row[0].isDirectDeliver
          this.basicData.outboundStorageCode = row[0].storageCode;
          this.basicData.outboundStorageName = row[0].storageName;
          this.warehouse.query.warehouseNo = row[0].storageCode;
          if (this.warehouseCode != row[0].storageCode) {
            this.warehouseCode = row[0].storageCode;
            this.tableData = [];
          }
        } else {
          this.basicData.outboundStorageCode = '';
          this.basicData.outboundStorageName = '';
          this.warehouse.query.warehouseNo = '';
          this.warehouseCode = '';
        }
      },
      //选中业务员
      setSalesman(val, row) {
        if (row && row.length > 0) {
          this.basicData.returnSalesmanNo = row[0].id;
          this.basicData.returnSalesmanName = row[0].personName;
        } else {
          this.basicData.returnSalesmanNo = '';
          this.basicData.returnSalesmanName = '';
        }
      },
      //选中仓库(供应商)
      setWarehouseIn(val, row) {
        if (row && row.length > 0) {
          this.basicData.supplierStorageCode = row[0].storageCode;
          this.basicData.supplierStorageName = row[0].storageName;
        } else {
          this.basicData.supplierStorageCode = '';
          this.basicData.supplierStorageName = '';
        }
      },

      //切换公司
      changeCompany(val) {
        //locations是v-for里面的也是datas里面的值
        let value = this.companyList.find((item) => item.personCompanyCode === val);
        this.basicData.returnDepartmentCode =
          this.basicData.partnerCode =
          this.basicData.partnerName =
          this.partnerCode =
            '';
        this.businessDepartmentList = [];
        if (value) {
          this.getCurrany(val);
          this.initDepartment();
          this.tableData = [];
          this.$refs.exchangeTable.updateData();
          //调币种类接口

          // let params = {
          //   fromCurrencyCode:this.tableData[0].returnCurrencyCode,
          //   toCurrencyCode:this.currencyCode,
          //   purchaseReturnDetails:this.tableData,
          // }
          // this.$axios.post(API.PURCH_CHANGE_LEGER_CODE_NAME,params).then(item=>{
          //   if(item.data.code==0){
          //     this.tableData = item.data.data.purchaseReturnDetails;
          //     this.tableData.forEach(rs=>{
          //       rs.returnCurrencyCode=this.currencyCode;
          //       rs.returnCurrencyName=this.currencyName;
          //     })
          //     this.$refs.exchangeTable.updateData()
          //       this.tableData = []
          //   }else{
          //     this.basicData.returnCompanyCode = this.returnOldBlurCode;
          //     this.$alert(this.$t("businessReceiptList.table.pleaseMakeExchangeRate"));
          //   }
          // }).finally(()=>{
          //    this.initDepartment();
          // })
        }
      },
      //切换部门
      changeDepartment() {
        this.$refs.searchModal.blurModal();
        this.tableData = [];
        this.basicData.partnerCode = '';
        this.basicData.partnerName = '';
        this.partnerCode = '';
      },
      getCurrany(val) {
        return new Promise((resolve, reject) => {
          this.$axios.get(API.GET_LEGER_CODE_NAME, { companyCode: val }).then((res) => {
            if (res.data.code == 0) {
              if (res.data.data) {
                this.returnOldCompanyCode = val;
                this.basicData.companyCurrencyCode = res.data.data.currencyCode;
                this.basicData.companyCurrencyName = res.data.data.currencyName;
                this.currencyCode = res.data.data.currencyCode;
                this.currencyName = res.data.data.currencyName;
                resolve(res);
              } else {
                this.basicData.returnCompanyCode = this.returnOldCompanyCode;
                this.initDepartment();
                this.$alert(this.$t('addInvoice.warnInfo.ledgerInfo'));
                reject();
              }
            } else {
              reject();
            }
          });
        });
      },
      //修改是否退款
      changeIsReturnMoney(val) {
        this.isReturnMoney = val;
        this.$refs.exchangeTable.refreshColumn();
      },
      //修改性质
      changeMethord(val) {
        console.log(val);
        // let _self = this;
        // setTimeout(function () {
        //   let tableData = [];
        //   // if(val == 0 ){
        //   //   _self.$refs.returnTable.setVal(tableData)
        //   // }else{
        //   //   _self.$refs.exchangeTable.setVal(tableData)
        //   // }
        // }, 1000);
      },
      //修改运费金额
      handleChangeNumber(val) {
        this.basicData.freightAmount = val;
      },
      //点击表格记录正在编辑哪一行
      rowClick(value) {
        this.rowIndex = value.$rowIndex;
      },
      //查汇率
      getExchangeRate() {
        const params = {
          fromCurrencyCode: this.basicData.returnCurrencyCode,
          toCurrencyCode: this.basicData.companyCurrencyCode,
        };
        return new Promise((resolve, reject) => {
          if (!this.basicData.returnCurrencyCode) {
            resolve();
          }
          if (this.basicData.returnCurrencyCode == this.basicData.companyCurrencyCode) {
            this.basicData.currencyExchangeRate = 1;
            resolve();
          } else {
            this.$axios.post(DataBaseAPI.GET_CURRENCY_EXCHANGE, params).then((res) => {
              if (res.data.code === 0) {
                if (res.data.data) {
                  this.basicData.currencyExchangeRate = res.data.data.positiveRate;
                }
                resolve(res);
              } else {
                this.$alert(res.data.msg);
                reject();
              }
            });
          }
        });
      },
      //选择业务入库批次
      setInboundNo(model, value, row) {
        console.log(model, value, row);
        if (value && value.length > 0) {
          //合同号
          this.basicData.contractNo = value[0].contractNo;
          //货币
          this.basicData.returnCurrencyCode = value[0].currencyTypeCode;
          this.basicData.returnCurrencyName = value[0].currencyTypeName;
          this.getExchangeRate().then(() => {
            const params = {
              purchaseReturnDetails: [],
              currencyExchangeRate: this.basicData.currencyExchangeRate,
            };
            params.purchaseReturnDetails.push(this.tableData[this.rowIndex]);

            this.$refs.exchangeTable.updateData();
            if (value[0].currencyTypeCode) {
              this.$axios.post(API.CALCULATE_AMOUNT, params).then((res) => {
                if (res.data.code == 0) {
                  this.tableData[this.rowIndex].businessContractPrice =
                    res.data.data.purchaseReturnDetails[0].priceWithTax;
                  this.updateRow(
                    this.tableData[this.rowIndex],
                    res.data.data.purchaseReturnDetails[0]
                  );
                  this.$refs.exchangeTable.updateData();
                } else {
                  for (let i in this.tableData[this.rowIndex]) {
                    this.tableData[this.rowIndex][i] = '';
                  }
                  this.$refs.exchangeTable.updateData();
                  this.$alert(this.$t('businessReceiptList.table.pleaseMakeExchangeRate'));
                }
              });
            }
          });
        }
      },
      updateRow(row, rowData) {
        let amountProps = [
          'priceWithTax',
          'priceWithoutTax',
          'returnAmount',
          'returnAmountWithoutTax',
        ];
        amountProps.forEach((prop) => {
          if (rowData && rowData[prop]) {
            row[prop] = Number(rowData[prop]).toFixed(6);
            row[prop + 'Local'] = Number(rowData[prop + 'Local']).toFixed(6);
          } else {
            row[prop] = 0;
            row[prop + 'Local'] = 0;
          }
        });
        row.productQuantity = rowData.productQuantity;
        if (this.$refs.exchangeTable) {
          this.$refs.exchangeTable.reloadRow(row);
        }
      },
      inputReturnAmount() {
        if (this.tableData[this.rowIndex].returnQuantity) {
          this.setQuantity(this.tableData[this.rowIndex].returnQuantity);
        }
      },
      // 接口加法计算
      calculateAdd(adds) {
        return new Promise((resolve, reject) => {
          this.$axios.post(API.GET_ADD_AMOUNT, { adds }).then((res) => {
            if (0 == res.data.code) {
              resolve(res.data.data);
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
              reject();
            }
          });
        });
      },
      calculateQuantity(val, row, scope) {
        // 求所有同业务批次和业务入库单号的已填写的数量和 总可退换货量-已填写的退换货数量总和 = 限制数字
        let numAdds = [];
        this.$refs.exchangeTable.getTableData().fullData.map((item) => {
          if (
            item._XID != scope.rowid &&
            scope.row.businessInboundNo == item.businessInboundNo &&
            scope.row.businessInboundBatchNo == item.businessInboundBatchNo
          ) {
            numAdds.push(item.returnQuantity);
          }
        });
        Promise.resolve(this.calculateAdd(numAdds)).then((res) => {
          // 计算总数量
          let limitNum = this.$cal.calCommon(row.quantity, res, '-');
          // 限制填写的退换货数量
          if (Number(row.returnQuantity) > limitNum) {
            row.returnQuantity = limitNum;
          }
          this.getAmount(val, row, scope);
        });
      },
      //添加一行
      insetRow() {
        let obj = {
          contractNo: this.tableData.length != 0 ? this.tableData[0].contractNo : '', // 采购合同号
          externalContractNo: '', // 外部合同号
          contractDetailNo: '', // 采购合同行项目号
          productCode: '', // 商品编码
          productName: '', // 商品描述
          businessInboundNo: '', // 业务入库单号
          returnQuantity: '', // 退货数量
          businessInboundBatchNo: '', // 业务入库批次
          batchNo: '', // 退货批次号
          priceWithTax: '', // 单价
          priceWithoutTaxLocal: '', // 不含税单价
          returnAmountWithoutTaxLocal: '', // 不含税金额
          returnAmount: '', // 金额
          returnCurrencyCode: '', // 币种代码
          returnCurrencyName: '', // 币种
          productUnit: '', // 单位
          exchangeRate: '', // 汇率
          invoiceQuantity: '', // 已匹配数量
          nonInvoiceQuantity: '', // 可匹配数量
          actualOutboundQuantity: '', // 实际出库数量
          inboundQuantity: '', // 入库数量
          quantity: '', // 可退货数量
          businessContractPrice: '', // 单价
        };
        if (!this.partnerCode) {
          this.$message({
            type: 'error',
            message: this.$t('purchaseReturn.msg.setPratner'),
          });
          return;
        }
        if (!this.warehouseCode) {
          this.$message({
            type: 'error',
            message: this.$t('purchaseReturn.msg.setWareHouse'),
          });
          return;
        }
        this.$refs.exchangeTable.validate().then(() => {
          this.tableData.push(obj);
        });
      },
      //获取可退货数量
      async getNumber(row) {
        if (row.batchNo) {
          let res = await this.$axios.get(API.GET_STORAGEFORPURCHASERETURN, {
            batchNo: row.batchNo,
          });
          if (res.data.code === 0) {
            let returnData = res.data.data;
            row.inboundQuantity = returnData.inboundQuantity;
            row.quantity = returnData.availableQuantity;
            row.businessContractPrice = returnData.inboundPrice;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        }
      },
      //修改数量
      setQuantity(val, row, scope) {
        if (val) {
          row.returnQuantity = val;
          this.calculateQuantity(val, row, scope);
          //TODO 计算金额
        } else {
          this.tableData[this.rowIndex].returnQuantity = '';
          this.tableData[this.rowIndex].returnAmount = '';
          this.tableData = this.$refs['exchangeTable'].getTableData().fullData;
        }
      },
      getAmount(val, row, scope) {
        console.log(val, row, scope);
        const params = {
          purchaseReturnDetails: [],
          currencyExchangeRate: this.basicData.currencyExchangeRate,
        };
        params.purchaseReturnDetails.push(row);
        this.$axios.post(API.CALCULATE_AMOUNT, params).then((res) => {
          if (res.data.code === 0) {
            // this.tableData[this.rowIndex].returnAmount = Number(res.data.data.returnAmount).toFixed(6)
            // this.tableData[this.rowIndex].returnAmountLocal = Number(res.data.data.returnAmountLocal).toFixed(6)
            // this.tableData[this.rowIndex].returnQuantity = val
            this.tableData[this.rowIndex].businessContractPrice =
              res.data.data.purchaseReturnDetails[0].priceWithTax;
            this.updateRow(this.tableData[this.rowIndex], res.data.data.purchaseReturnDetails[0]);
            this.tableData = this.$refs['exchangeTable'].getTableData().fullData;
          }
        });
      },
      //删除选中行
      removeSelected() {
        let data = this.$refs.exchangeTable.getSelectRecords();
        if (data && data.length > 0) {
          this.$confirmAction()
            .then(() => {
              this.$refs.exchangeTable.removeSelecteds();
              this.$refs.exchangeTable.updateStatus();
              this.tableData = this.$refs.exchangeTable.getTableData().fullData;
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('purchaseReturn.msg.delProduct'),
            type: 'error',
          });
        }
      },
      getData() {
        if (this.$route.query && this.$route.query.returnNo) {
          //如果是修改页面，先查询需要修改数据的详情
          this.$axios
            .get(API.UPDATE_PURCHASE_RETURN_API + '/' + this.$route.query.returnNo)
            .then((res) => {
              if (res.data.code === 0) {
                this.basicData = res.data.data;
                this.warehouseCode = this.basicData.outboundStorageCode;
                this.partnerCode = this.basicData.partnerCode;
                if (this.$route.query && this.$route.query.copy && this.$route.query.copy == '0') {
                  this.basicData.returnNo = null;
                  this.basicData.id = null;
                  this.basicData.version = null;
                }
                if (this.basicData.isReturnMoney == 0) {
                  this.isReturnMoney = false;
                  this.basicData.isReturnMoney = false;
                } else {
                  this.isReturnMoney = true;
                  this.basicData.isReturnMoney = true;
                }
                this.tableData = this.basicData.purchaseReturnDetailList;
                if (this.basicData.returnCompanyCode) {
                  this.getCurrany(this.basicData.returnCompanyCode);
                }
              }
            })
            .then(() => {
              this.companyList = JSON.parse(this.userInfo.userInfo.companyList);
              if (this.basicData.returnCompanyCode) {
                this.initDepartment();
              }
              this.gotoEdit();
              this.$nextTick(() => {
                this.$refs.basicData.clearValidate();
              });
              // 获取凭证ID 获取凭证列表
              this.entityDataId = this.basicData.id;
              this.getAccountEntry();
            });
        } else {
          this.tableData = [];
          this.$nextTick(() => {
            this.$refs.basicData.clearValidate();
          });
        }
      },
      //更新表格数据
      updateTableData(data) {
        this.tableData = data;
      },
      //提交
      commit() {
        if (this.tableData.length === 0) {
          return this.$message({
            showClose: true,
            message: this.$t('purchaseReturn.msg.addCapableData'),
            type: 'error',
          });
        }
        this.$refs.basicData.validate((valid) => {
          if (valid) {
            //校验表格
            // let tableName = 'exchangeTable';
            // if (this.basicData.isReturn === 0) {
            //   tableName = 'returnTable';
            // }
            this.$refs.exchangeTable.validate((valid) => {
              if (valid) {
                let batchNoList = this.tableData.map((item) => {
                  return item.batchNo;
                });
                let noRepeatBatchNoList = Array.from(new Set(batchNoList));
                if (batchNoList.length != noRepeatBatchNoList.length) {
                  return this.$message({
                    showClose: true,
                    message: '退货批次号不能重复！',
                    type: 'error',
                  });
                }
                this.saveData(1);
              }
            });
          }
        });
      },
      //打印
      print() {
        return this.$message({
          type: 'error',
          message: '该功能暂未开放',
        });
      },
      //保存
      save() {
        this.saveData(0);
      },
      saveData(type, cancelValidate = false) {
        this.loading.startLoading();
        let data = this.basicData;
        data.cancelValidate = cancelValidate; //二次提交
        data.type = type;
        data.tenantCode = this.userInfo.userInfo.tenantCode;
        data.companyCode = this.userInfo.userInfo.companyCode;
        data.companyName = this.userInfo.userInfo.companyName;
        data.departmentCode = this.userInfo.userInfo.departmentCode;
        data.departmentName = this.userInfo.userInfo.departmentName;
        this.companyList.find((item) => {
          if (item.personCompanyCode === this.basicData.returnCompanyCode) {
            this.basicData.returnCompanyName = item.personCompanyName;
          }
        });
        this.businessDepartmentList.map((item) => {
          if (item.personDepartmentCode == this.basicData.returnDepartmentCode) {
            this.basicData.returnDepartmentName = item.personDepartmentName;
          }
        });
        if (this.tableData && this.tableData.length > 0) {
          this.tableData.map((item, index) => {
            item.returnDetailNo = index + 1;
            item.sortno = index + 1;
            item.id = null;
          });
        }
        data.purchaseReturnDetailListStr = JSON.stringify(this.tableData);
        if (data.isReturnMoney) {
          data.isReturnMoney = 1;
        } else {
          data.isReturnMoney = 0;
        }
        data.isDirectDeliver = this.basicData.isDirectDeliver;
        let apiName = 'ADD_PURCHASE_RETURN_API';
        if (this.basicData.isDirectDeliver == '1' && this.basicData.returnStatus == 'ZT07') {
          apiName = 'UPDATE_ACTUALQUANTITY_API';
        }
        this.$axios.post(API[apiName], data).then((res) => {
          this.loading.endLoading();
          if (0 == res.data.code) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            if (type == 0) {
              if (this.$route.name == 'purchaseReturnAdd') {
                this.dblclickEvent(res.data.data);
              } else {
                this.getData();
              }
            } else {
              this.gotoList(this.$route.name);
            }
          } else if (10 == res.data.code) {
            // 提交时校验软提示
            this.$reportErrors({
              msg: res.data.msg,
              code: res.data.code,
              callback: () => {
                //确认提交，cancelValidate传值true取消校验
                this.saveData(type, true);
              },
            });
          } else {
            if (type == 1 && res.data.data && res.data.data.id) {
              if (this.$route.name == 'purchaseReturnAdd') {
                this.dblclickEvent(res.data.data);
              } else {
                this.getData();
              }
            }
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //保存--修改
      dblclickEvent(value) {
        let path = {
          fromPath: {
            path: '/purchase/purchaseReturnAdd',
            name: 'purchaseReturnAdd',
            meta: {
              keepAlive: true,
              title: this.$t('purchaseReturn.route.purchaseReturnAdd'),
            },
          },
          toPath: {
            path: '/purchase/purchaseReturnEdit',
            name: 'purchaseReturnEdit',
            meta: {
              keepAlive: false,
              title: this.$t('purchaseReturn.route.purchaseReturnEdit'),
            },
            query: {
              returnNo: value.returnNo,
              canEdit: '0',
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      // 确认
      doConfirmInfo(info, cancelValidate = false) {
        let params = {
          id: this.basicData.id,
          invoiceCode: this.basicData.returnNo,
          cancelValidate: cancelValidate,
          ...info,
        };
        this.$axios.post(API.DO_CONFIRM, params).then((res) => {
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: this.$t('message.success'),
              type: 'success',
            });
            this.getData();
          } else if (res.data.code === 10) {
            // 提交时校验软提示
            this.$reportErrors({
              msg: res.data.msg,
              code: res.data.code,
              callback: () => {
                //确认提交，cancelValidate传值true取消校验
                this.doConfirmInfo(info, true);
              },
            });
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },

      // 撤回
      async doWithdraw() {
        const baseData = {
          id: this.basicData.id,
        };
        this.load = true;
        this.$axios.post(API.DO_WITHDRAW, baseData).then((res) => {
          this.load = false;
          if (res.data.code == 0) {
            this.gotoList('purchaseReturnList');
          } else {
            this.$message({ showClose: true, type: 'error', message: res.data.msg });
          }
        });
      },
      //跳转到列表页面
      gotoList(name) {
        let path = {
          fromPath: {
            path: `/purchase/${name}`,
            name: name,
            meta: {
              keepAlive: true,
              title: this.$t(`purchaseReturn.route.${name}`),
            },
          },
          toPath: {
            path: '/purchase/purchaseReturnList',
            name: 'purchaseReturnList',
            meta: {
              keepAlive: false,
              title: this.$t('purchaseReturn.route.purchaseReturnList'),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //删除
      del() {
        this.$confirmAction()
          .then(() => {
            let ids = [];
            ids.push(this.basicData.id);
            let returnNos = [];
            returnNos.push(this.basicData.returnNo);
            this.$axios.post(API.DELETE_PURCHASE_RETURN_API, { returnNos, ids }).then((res) => {
              if (0 == res.data.code) {
                //如果操作成功，直接返回列表
                this.$message({
                  type: 'success',
                  message: this.$t('message.success'),
                });
                this.gotoList('purchaseReturnEdit');
              } else {
                //如果有错误返回，提示信息
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //编辑
      gotoEdit() {
        if (this.basicData.returnStatus == 'ZT06' || this.basicData.returnStatus == 'ZT05') {
          this.canNotEdit = false;
        }
      },
      //复制
      copy() {
        let path = {
          path: '/purchase/purchaseReturnCopy',
          name: 'purchaseReturnCopy',
          meta: {
            keepAlive: true,
          },
          query: { returnNo: this.basicData.returnNo, copy: '0' },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //生成物流运输单
      saveTransport() {
        //换货可能存在多个入库仓库，不同的入库仓库需要生成不同的物流运输单
        if (this.basicData.isReturn == 0) {
          let warehoseList = [];
          let warehouseData = {};
          if (this.tableData && this.tableData.length > 0) {
            this.tableData.map((item) => {
              if (warehouseData[item.inboundStorageNo]) {
                warehouseData[item.inboundStorageNo].data.push(item);
              } else {
                warehouseData[item.inboundStorageNo] = [];
                warehouseData[item.inboundStorageNo].push(item);
                warehoseList.push(item.inboundStorageNo);
              }
            });
          }
          for (let i = 0; i < warehoseList.length; i++) {
            this.saveDelivery(
              warehouseData[warehoseList[i]],
              warehoseList[i],
              warehouseData[warehoseList[i]][0].inboundStorageName
            );
          }
        } else {
          let params = {
            otherNo: this.$route.query.returnNo,
          };
          this.$axios.post(API.CALC_PICK_DELIVERY, params).then((res) => {
            if (res.data.code == 0) {
              if (res.data.data == 0) {
                this.saveDelivery(
                  this.tableData,
                  this.basicData.supplierStorageCode,
                  this.basicData.supplierStorageName
                );
              } else {
                this.$message({
                  showClose: true,
                  message: this.$t('purchaseReturn.msg.transTip'),
                  type: 'error',
                });
              }
            } else {
              this.$alert(res.data.msg);
            }
          });
        }
      },
      //保存物流运输单
      saveDelivery(deliveryDetailStr, warehouseCode, warehouseName) {
        let data = {};
        data.tenantCode = this.userInfo.userInfo.tenantCode;
        data.companyCode = this.userInfo.userInfo.companyCode;
        data.companyName = this.userInfo.userInfo.companyName;
        data.departmentCode = this.userInfo.userInfo.departmentCode;
        data.departmentName = this.userInfo.userInfo.departmentName;
        data.deliveryCreatePersonName = this.basicData.returnOperatorName;
        data.deliveryCreatePersonNo = this.basicData.returnOperatorNo;
        data.deliveryLoginCompany = this.userInfo.userInfo.companyName;
        data.deliveryType = '4';
        data.otherNo = this.basicData.returnNo;
        data.providerNo = this.basicData.partnerCode;
        data.providerName = this.basicData.partnerName;
        data.salesmanNo = this.basicData.returnSalesmanNo;
        data.salesmanName = this.basicData.returnSalesmanName;
        data.deliveryDepartment = this.userInfo.userInfo.departmentName;
        data.pickupStorageNo = this.basicData.outboundStorageCode;
        data.pickupStorageName = this.basicData.outboundStorageName;
        data.shiptoStorageName = warehouseName;
        data.deliveryStatus = 1;
        let productList = [];
        deliveryDetailStr.map((item, index) => {
          let obj = {
            other_no: index + 1,
            providerNo: this.basicData.partnerCode,
            providerName: this.basicData.partnerName,
            productNo: item.productCode,
            productName: item.productName,
            deliveryQuantity: item.returnQuantity,
            contractUnit: item.unit,
          };
          productList.push(obj);
        });
        data.deliveryDetailStr = JSON.stringify(productList);
        this.$axios.post(API.SAVE_DELIVERY, data).then((res) => {
          if (0 == res.data.code) {
            //如果操作成功，直接返回列表
            this.$message({
              type: 'success',
              message: this.$t('message.success'),
            });
          } else {
            //如果有错误返回，提示信息
            this.$alert(res.data.msg);
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .topFrom {
    padding: 26px 20px 8px 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 17px 0px rgba(72, 89, 102, 0.16);
    border-radius: 3px;
  }
  .gird {
    margin-top: 10px;
    padding: 12px 20px 20px 20px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 17px 0px rgba(72, 89, 102, 0.16);
    border-radius: 3px;
  }
  .padding-bottom {
    padding-bottom: 80px;
  }
</style>
